/** @jsxImportSource @emotion/react */
import { ScheduleEvent } from "../../../common/context/SharedFormTypes"
import { getWeddingMuiIconElement } from "./ScheduleIconPicker"
import { SectionCard } from "./SectionCard"

interface ScheduleEventCardProps {
    event: ScheduleEvent
    primaryColor: string
    onClick: () => void
    onDelete: () => void
}

export const ScheduleEventCard = ({ event, primaryColor, onClick, onDelete }: ScheduleEventCardProps) => {
    const icon = event.iconType === 'emoji'
        ? event.iconValue
        : getWeddingMuiIconElement(event.iconValue)

    return (
        <SectionCard
            title={event.title}
            subtitle={event.time || undefined}
            icon={icon}
            isMuiIcon={event.iconType === 'mui'}
            primaryColor={primaryColor}
            onClick={onClick}
            onDelete={onDelete}
        />
    )
}
